<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="DateFrom"
      [matDatepicker]="pickerFrom"
      placeholder="Fecha desde"
      required
    />
    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
    <mat-datepicker #pickerFrom></mat-datepicker>
    <mat-error *ngIf="f.DateFrom.errors && f.DateFrom.errors.required">
      Ingrese la fecha desde
    </mat-error>
  </mat-form-field>
  <mat-form-field class="margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="DateTo"
      [matDatepicker]="pickerTo"
      placeholder="Fecha hasta"
      required
    />
    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
    <mat-datepicker #pickerTo></mat-datepicker>
    <mat-error *ngIf="f.DateTo.errors && f.DateTo.errors.required">
      Ingrese la fecha desde
    </mat-error>
  </mat-form-field>

  <mat-form-field class="full-width">
    <input
      type="text"
      #physician
      matInput
      placeholder="Médico"
      formControlName="Physician"
      [matAutocomplete]="autPhysician"
    />
    <mat-autocomplete
      #autPhysician="matAutocomplete"
      [displayWith]="filterCompletePhysicians.displayFn"
    >
      <mat-option
        *ngFor="let physician of filteredPhysiciansOptions | async"
        [value]="physician"
      >
        {{ physician.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <div class="full-width">
    <patient-autocomplete formControlName="Patient"></patient-autocomplete>
  </div>
  <mat-form-field class="medium-width">
    <input
      type="text"
      #center
      matInput
      placeholder="Centro"
      formControlName="Center"
      [matAutocomplete]="autCenter"
    />
    <mat-autocomplete
      #autCenter="matAutocomplete"
      [displayWith]="filterCompleteCenters.displayFn"
    >
      <mat-option
        *ngFor="let center of filteredCentersOptions | async"
        [value]="center"
      >
        {{ center.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
    <input
      type="text"
      #equipment
      matInput
      placeholder="Equipo"
      formControlName="Equipment"
      [matAutocomplete]="autEquipment"
    />
    <mat-autocomplete
      #autEquipment="matAutocomplete"
      [displayWith]="filterCompleteEquipments.displayFn"
    >
      <mat-option
        *ngFor="let equipment of filteredEquipmentsOptions | async"
        [value]="equipment"
      >
        {{ equipment.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
    <input
      type="text"
      #doctor
      matInput
      placeholder="Servicio"
      formControlName="Service"
      [matAutocomplete]="autService"
    />
    <mat-autocomplete
      #autService="matAutocomplete"
      [displayWith]="filterCompleteServices.displayFn"
    >
      <mat-option
        *ngFor="let service of filteredServicesOptions | async"
        [value]="service"
      >
        {{ service.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
    <input
      type="text"
      #practiceRegion
      matInput
      placeholder="Práctica"
      formControlName="PracticeRegion"
      [matAutocomplete]="autPracticeRegion"
    />
    <mat-autocomplete
      #autPracticeRegion="matAutocomplete"
      [displayWith]="filterCompletePracticesRegion.displayFn"
    >
      <mat-option
        *ngFor="let practiceRegion of filteredPracticesRegionOptions | async"
        [value]="practiceRegion"
      >
        {{ practiceRegion.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

   <mat-form-field class="medium-width">
    <input
      type="text"
      #entity
      matInput
      placeholder="Entidades"
      formControlName="Entity"
      [matAutocomplete]="autEntity"
    />
    <mat-autocomplete
      #autEntity="matAutocomplete"
      [displayWith]="filterCompleteEntities.displayFn"
    >
      <mat-option
        *ngFor="let entity of filteredEntitiesOptions | async"
        [value]="entity"
      >
        {{ entity.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <br>

  <mat-checkbox class="margin-right-small" formControlName="Over"
    >Ver sobreturnos</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="Cancel"
    >Ver cancelados</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="Atended"
    >Ver atendidos</mat-checkbox
  >

  <mat-checkbox
    class="margin-right-small"
    formControlName="IsPatientDataValidated"
    ><span>Validado datos paciente</span>
  </mat-checkbox>
  <mat-checkbox
    class="margin-right-small"
    formControlName="IsDocumentationValidated"
    ><span>Validada documentación</span>
  </mat-checkbox>
  <mat-checkbox
    class="margin-right-small"
    formControlName="IsMedicalRecordValidated"
    ><span>Validada HCE</span>
  </mat-checkbox>
  <mat-checkbox
    class="margin-right-small"
    formControlName="IsProcedureValidated"
    ><span>Validadas prácticas</span>
  </mat-checkbox>
  <mat-checkbox
    class="margin-right-small"
    formControlName="IsReferredToCallCenter"
    ><span>Derivado a Call Center</span>
  </mat-checkbox>

  <mat-checkbox class="margin-right-small" formControlName="WithFiles"
    ><span>Posee documentación adjunta</span>
  </mat-checkbox>

  <mat-checkbox formControlName="OrderByPatient"
    ><span>Ordenar por paciente</span>
  </mat-checkbox>

  <mat-checkbox formControlName="OrderByDate"
    ><span>Ordenar por fecha y hora</span>
  </mat-checkbox>
</form>
